import React, { useEffect, useMemo, useState } from "react";
import { Card, Col, Table } from "react-bootstrap";
 
import { useNavigate, useParams } from "react-router-dom";
import { Badge, Dropdown } from "react-bootstrap";

import toast from "react-hot-toast";
import { TableLoaderRow, TableEmptyRow } from "../components/TableLoader";
import Pagination from "../components/Pagination";
import {
  blockUser,
  getUserDetail,
  getUserEvent,
  getUserEventGuest,
  getUserList,
  updateGuestStatus,
} from "../../services/UserServices/UserService";
import { useLocation } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { debounce, set } from "lodash";
 

export default function Guest(props) {
  const location = useLocation();
  const historyData = location.state?.history;
 
  console.log("historyData", historyData?.event);
  const [debouncedSearch, setDebouncedSearch] = useState("");
const [search,setSearch]=useState("")
  const [loader, setLoader] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
 
  // const [isBlocked, setIsBlocked] = useState(false);
   const { id1,id2 } = useParams();
   const [sortBy,setSortBy]=useState("")
const [selectedGuests, setSelectedGuests] = useState([]);
const [selectAll, setSelectAll] = useState(false);
const [host,selectedHost]=useState(null)
    
   const debouncedHandler = useMemo(
    () =>
      debounce((value) => {
        // 🔥 hit API only if 3+ chars OR empty (for reset)
        if (value.length >= 1 || value.length === 0) {
          setDebouncedSearch(value);
          setCurrentPage(0); // reset pagination
        }
      }, 800),
    []
  );
  
  useEffect(() => {
    return () => {
      debouncedHandler.cancel();
    };
  }, []);
const [user, setUser] = useState();
   
  const [loading, setLoading] = useState(true);
 
   const getData = async () => {
      
        try {
          setLoader(true); 
          const res = await getUserEventGuest(id2,currentPage,10,debouncedSearch,sortBy);
          
          setUser(res?.data?.data?.guests);
          selectedHost(res?.data?.data?.guests[0]?.invite?.host)
          setTotalPages(res?.data?.data?.count);
       
        } catch (error) {
          console.error(error?.response?.data?.message);
        }
        finally{
          setLoader(false);
        }
      };
  useEffect(() => {
     
      if (id2) {
        getData();
      }
     }, [currentPage,debouncedSearch,sortBy]);
  
 


const handleExportCSV = async () => {
  try {
    // 🚫 No selection
    if (selectedGuests.length === 0) {
      return toast.error("Please select at least one guest to download");
    }

    // ✅ Fetch all guests once (or use already loaded data if you prefer)
    const res = await getUserEventGuest(id2, 0, 10000);
    const guests = res?.data?.data?.guests || [];

    // ✅ Filter only selected guests
    const selectedData = guests.filter(g =>
      selectedGuests.includes(g._id)
    );

    if (selectedData.length === 0) {
      return toast.error("Selected guests not found");
    }

    // ✅ CSV headers
    const headers = ["Name", "Phone Number", "Status"];

    // ✅ CSV rows
    const csvRows = [
      headers.join(","),
      ...selectedData.map(g =>
        [
          `"${g.name}"`,
          `"${g.countryCode} ${g.phoneNumber}"`,
          `"${g.invite?.status || ""}"`
        ].join(",")
      )
    ].join("\n");

    // ✅ Download CSV
    const blob = new Blob([csvRows], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "selected_guests.csv";
    document.body.appendChild(link);
    link.click();
    link.remove();

    toast.success(`${selectedData.length} guests downloaded`);
  } catch (err) {
    console.error(err);
    toast.error("Failed to export CSV");
  }
};

 
 const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

const handleSelectGuest = (id) => {
  setSelectedGuests((prev) =>
    prev.includes(id) ? prev.filter((guestId) => guestId !== id) : [...prev, id]
  );
};

const handleSelectAll = () => {
  if (selectAll) {
    setSelectedGuests([]);
  } else {
    setSelectedGuests(user?.map((g) => g._id));
  }
  setSelectAll(!selectAll);
};


const bulkUpdateStatus = async (status) => {

  if (selectedGuests.length === 0) {
    return toast.error("Please select at least one guest");
  }

  try {
    setLoader(true);
console.log(selectedGuests)
    const payload={
      hostId:id1,
      guestIds:selectedGuests,
      status:status
      
    }
     
    await updateGuestStatus(payload); // 👈 your API endpoint
    toast.success(`Status updated to ${status} for ${selectedGuests.length} guests`);
    setSelectedGuests([]);
    setSelectAll(false);
    getData(); // refresh list
  } catch (err) {
    toast.error("Something went wrong");
  } finally {
    setLoader(false);
  }
};




const updateStatus = async (data,status) => {
  
  try {
    setLoader(true);
const payload={
  hostId:data?.invite?.host,
  guestIds:[data?._id],
  status:status,
  eventId:data?.invite?.event
}
    await updateGuestStatus(payload); // 👈 your API endpoint
    toast.success(`Status updated `);
    
    getData(); // refresh list
  } catch (err) {
    toast.error("Something went wrong");
  } finally {
    setLoader(false);
  }
};

  
  const totalItems = totalPages;
  const total = Math.ceil(totalItems / itemsPerPage);

 
   
  return (
 <div className="qx-page">

    {/* <PageTitle
          motherMenu="User List"
          activeMenu={`${historyData?.user?.hostName ? historyData?.user?.hostName : "User"} >  ${historyData?.event?.name || "Event"} > Guests`}
          pathBack={true}   
        /> */}
     <PageTitle
  breadcrumbs={[
    {
      label: "User List",
      path: "/user-management",
    },
    {
      label: historyData?.user?.hostName || "User",
      path: `/user-details/${historyData?.user?._id}`,
    },
    {
      label: historyData?.event?.name || "Event",
      path: `/user_events/${historyData?.user?._id}`,
   state: {
        history: {
          user: historyData?.user,
          event: historyData?.event,
        },
      },
    },
    {
      label: "Guests",
    },
  ]}
/>
  


      <div className="d-flex justify-content-between mb-3" >
  <h5></h5>
  
  <Dropdown>
    <Dropdown.Toggle style={{padding:"3px",backgroundColor:"#A60000" , border:0}}  >
     Update Status
    </Dropdown.Toggle>

    <Dropdown.Menu>
      <Dropdown.Item onClick={() => bulkUpdateStatus("accepted")}>Mark as Accepted</Dropdown.Item>
      <Dropdown.Item onClick={() => bulkUpdateStatus("rejected")}>Mark as Rejected</Dropdown.Item>
      
    </Dropdown.Menu>
    <button
  className="btn"
  style={{
    backgroundColor: "#A60000",
    color: "white",
    padding: "4px 10px",
    borderRadius: "6px",
    marginLeft: "10px",
    opacity: selectedGuests.length === 0 ? 0.6 : 1,
    cursor: selectedGuests.length === 0 ? "not-allowed" : "pointer"
  }}
  disabled={selectedGuests.length === 0}
  onClick={handleExportCSV}
>
  Download
</button>

  </Dropdown>
</div>
       
  <div className="pb-2 d-flex justify-content-between gap-2">
        <input
          type="text"
          style={{ borderRadius: "0.5rem", width: "100%" }}
          className="form-control inpp"
          placeholder="Search by name, phone-number"
          value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    debouncedHandler(e.target.value);
  }}
        />
         {/* <select
    className="form-control"
    style={{ borderRadius: "0.5rem", width: "200px" }}
    value={sortBy}
    onChange={(e) => setSortBy(e.target.value)}
  >
    <option value="">Sort by</option>
    <option value="name">Name</option>
  </select> */}
      </div>
      <Card className="qx-table-card">
        <Card.Body>
          <Table responsive>
            <thead style={{color:"#A60000"}}>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
                <th>
                  <strong>S.NO</strong>
                </th>
                <th>
                  <strong>Name</strong>
                </th>
                <th>
                  <strong>Phone Number</strong>
                </th>
                <th>
                  <strong>RSVP Status</strong>
                </th>
                <th>
                  <strong>Action</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <TableLoaderRow colSpan={6} />
              ) : !user?.length ? (
                <TableEmptyRow colSpan={6} message="No guests found" />
              ) : (
                user?.map((guest, index) => (
                    <tr style={{  color: "#A60000"}} key={index}>
                      <td>
  <input
    type="checkbox"
    checked={selectedGuests.includes(guest?._id)}
    onChange={() => handleSelectGuest(guest?._id)}
  />
</td>


                      <td>{index + 1 + currentPage * itemsPerPage}</td>
                    
                      
                      <td>
                        <span className="w-space-no">{guest?.name}</span>
                      </td>
 
                      
                      <td>
                        <span className="w-space-no">
   {guest?.countryCode} {guest?.phoneNumber}
                        </span>
                      </td>
          
                      <td className={`${guest?.invite?.status==="accepted"?"acc1":"rej1"}`}>
                       {guest?.invite?.status?.charAt(0).toUpperCase()+guest?.invite?.status.slice(1).toLowerCase()}
                      </td>
                      <td className="qx-table-actions-cell">
                        <Dropdown align="end">
                          <Dropdown.Toggle variant="light" className="qx-action-toggle">
                                           {svg1}
                                         </Dropdown.Toggle>
                                         <Dropdown.Menu align="end">
                                           
                     
                                            {guest?.invite?.status === "pending" &&  (
                                               <>
                                                <Dropdown.Item
                                                onClick={()=> updateStatus(guest,"accepted")}
                                           
                                             >
                                              Accept
                                             </Dropdown.Item>
                                        <Dropdown.Item
                                                onClick={()=> updateStatus(guest,"rejected")}
                                           
                                             >
                                              Reject
                                             </Dropdown.Item>
                                         
                                               </>
                                            )}
                                            

                                             {guest?.invite?.status === "accepted" &&  (
                                         <Dropdown.Item
                                         
                                             onClick={()=> updateStatus(guest,"rejected")}
                                             >
                                               Reject
                                             </Dropdown.Item>
                                          )}
                                      


                                             {guest?.invite?.status === "rejected" &&  (
                                         <Dropdown.Item
                                             onClick={()=> updateStatus(guest,"accepted")}
                                             >
                                               Accept
                                             </Dropdown.Item>
                                          )}
                     
                                            
                                         </Dropdown.Menu>
                                       </Dropdown>
                                     </td>
                    </tr>
                ))
              )}
            </tbody>
          </Table>

          {!loader && user?.length > 0 && (
            <Pagination
              pageCount={total}
              pageValue={currentPage}
              setPage={setCurrentPage}
              total={totalItems}
              pageSize={itemsPerPage}
            />
          )}
        </Card.Body>
      </Card>
     
    </div>
  );
}
